module.exports = __webpack_public_path__ + "static/img/hotline.acaa32b8.png";